import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";
import { db } from "./firebase";
import { Faixa, FaixaForm } from "@/types/playlist";

const COL = "playlist";

export function extrairVideoId(url: string): string {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/\s]{11})/,
  ];
  for (const p of patterns) {
    const m = url.match(p);
    if (m) return m[1];
  }
  return url; // assume que já é um ID
}

export async function listarPlaylist(): Promise<Faixa[]> {
  const q = query(collection(db, COL), orderBy("ordem", "asc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => {
    const data = d.data();
    return {
      id: d.id,
      artista: data.artista,
      musica: data.musica,
      linkYoutube: data.linkYoutube,
      ordem: data.ordem ?? 0,
      criadoEm: (data.criadoEm as Timestamp)?.toDate() ?? new Date(),
    };
  });
}

export async function adicionarFaixa(dados: FaixaForm): Promise<string> {
  const ref = await addDoc(collection(db, COL), {
    ...dados,
    criadoEm: serverTimestamp(),
  });
  return ref.id;
}

export async function atualizarFaixa(id: string, dados: Partial<FaixaForm>): Promise<void> {
  await updateDoc(doc(db, COL, id), dados);
}

export async function deletarFaixa(id: string): Promise<void> {
  await deleteDoc(doc(db, COL, id));
}
